import React, { useState } from 'react'
import AdThumb from '../AdThumb'
import AdInfo from '../AdInfo'
import MoAdPlayer from './MoAdPlayer'

const MoAdItem = ({
    src,
    profileSrc,
    advertiser,
    title,
    videoUrl,
    adUrl,
    trackingEvents,
    clickLogUrl
}) => {
    const [isOpenedMoPlayer, setIsOpenedPlayer] = useState(false)

    const handleMoAdClick = () => {
        setIsOpenedPlayer(true)
    }

    const handleMoAdClose = () => {
        setIsOpenedPlayer(false)
    }

    return (
        <div className={`vod-box a_d_box ${isOpenedMoPlayer ? 'playerActive' : ''}`}>
            <AdThumb src={src} handleMoAdClick={handleMoAdClick} />
            <AdInfo profileSrc={profileSrc} advertiser={advertiser} title={title} adUrl={adUrl} clickLogUrl={clickLogUrl} />

            <MoAdPlayer
                handleMoAdClose={handleMoAdClose}
                videoUrl={videoUrl}
                src={src}
                isOpenedMoPlayer={isOpenedMoPlayer}
                adUrl={adUrl}
                trackingEvents={trackingEvents} 
                clickLogUrl={clickLogUrl} 
            />
        </div>
    )
}

export default MoAdItem